'use strict';

import {DOM} from '@levcharity/resources/scripts/helpers/DOM.js';

export class MyAccountSettings {
    #settingsContainer;

    constructor() {
        this.#settingsContainer = DOM.el('.my-account-settings-container');
        if (this.#settingsContainer) {
            this.#handleProfileButton();
            this.#handleSettingsFormSubmit();
        }
    }

    #handleProfileButton() {
        const profilePictureWrapper = DOM.el('.profile-picture-wrapper', this.#settingsContainer);
        if (!profilePictureWrapper || profilePictureWrapper.dataset.profileUploadBound === '1') {
            return;
        }

        profilePictureWrapper.dataset.profileUploadBound = '1';

        const fileInput = DOM.el('input.profile-picture-input', profilePictureWrapper);
        const button = DOM.el('.profile-picture-upload-button', profilePictureWrapper);
        const imageWrapper = DOM.el('.image-wrapper', profilePictureWrapper);
        const saveButton = DOM.el('.save_account_button', this.#settingsContainer);

        if (!button || !fileInput) {
            return;
        }

        let pickerOpen = false;

        const releasePicker = () => {
            pickerOpen = false;
        };

        const openPicker = (event) => {
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();

            if (pickerOpen) {
                return;
            }

            pickerOpen = true;
            fileInput.addEventListener('change', releasePicker, {once: true});
            fileInput.addEventListener('cancel', releasePicker, {once: true});
            fileInput.click();
        };

        button.addEventListener('click', openPicker, true);

        fileInput.addEventListener('change', () => {
            const file = fileInput.files?.[0];
            if (!file) {
                return;
            }

            let previewImage = imageWrapper?.querySelector('img');
            if (!previewImage && imageWrapper) {
                previewImage = document.createElement('img');
                previewImage.alt = '';
                imageWrapper.appendChild(previewImage);
            }

            imageWrapper?.querySelectorAll('img').forEach((img, index) => {
                if (index > 0) {
                    img.remove();
                }
            });

            const reader = new FileReader();
            reader.onload = (e) => {
                if (previewImage) {
                    previewImage.src = e.target.result;
                }
            };
            reader.readAsDataURL(file);

            if (saveButton) {
                saveButton.disabled = false;
            }
        });
    }

    #handleSettingsFormSubmit() {
        const form = DOM.el('.edit-account-form', this.#settingsContainer);
        const saveButton = DOM.el('.save_account_button', this.#settingsContainer);
        const messagesContainer = DOM.el('.edit-account-messages', this.#settingsContainer);

        if (!form || !saveButton) {
            return;
        }

        saveButton.addEventListener(
            'click',
            (event) => {
                event.stopImmediatePropagation();
                event.preventDefault();

                if (messagesContainer) {
                    messagesContainer.style.display = 'none';
                }

                const formData = new FormData(form);
                formData.set('action', form.dataset.action || 'levcharity_my_account_edit');
                formData.set('levcharity_my_account_edit_nonce', form.dataset.token || '');

                const nicknameInput = form.querySelector('input[name="nickname"]');
                const initialNickname = (nicknameInput?.dataset.initialValue || '').trim().toLowerCase();
                const currentNickname = (nicknameInput?.value || '').trim().toLowerCase();
                if (nicknameInput && initialNickname !== '' && initialNickname === currentNickname) {
                    formData.delete('nickname');
                    formData.set('__w4f_preserve_nickname', nicknameInput.value);
                }

                if (formData.get('billing_email')) {
                    formData.set('email', formData.get('billing_email'));
                }
                if (formData.get('billing_first_name')) {
                    formData.set('first_name', formData.get('billing_first_name'));
                }
                if (formData.get('billing_last_name')) {
                    formData.set('last_name', formData.get('billing_last_name'));
                }

                const ajaxUrl = typeof admin_ajax !== 'undefined' && admin_ajax?.[0] ? admin_ajax[0] : '/wp-admin/admin-ajax.php';

                saveButton.disabled = true;

                fetch(ajaxUrl, {
                    method: 'POST',
                    body: formData,
                    credentials: 'same-origin',
                })
                    .then((response) => response.json())
                    .then((response) => {
                        this.#showMessage(
                            messagesContainer,
                            response.messages || response.message || 'Changes saved successfully!',
                            Boolean(response.success)
                        );

                        if (response.success) {
                            const fileInput = form.querySelector('input[name="profile_picture"]');
                            if (fileInput) {
                                fileInput.value = '';
                            }
                            window.setTimeout(() => {
                                window.location.reload();
                            }, 800);
                        } else {
                            saveButton.disabled = false;
                        }
                    })
                    .catch(() => {
                        this.#showMessage(messagesContainer, 'An error occurred. Please try again.', false);
                        saveButton.disabled = false;
                    });
            },
            true
        );
    }

    #showMessage(container, messages, isSuccess) {
        if (!container) {
            return;
        }

        const messageArray = Array.isArray(messages) ? messages : [messages];
        container.innerHTML = messageArray.map((msg) => `<div>${msg}</div>`).join('');

        if (isSuccess) {
            container.style.backgroundColor = '#d4edda';
            container.style.color = '#155724';
            container.style.borderLeft = '4px solid #28a745';
        } else {
            container.style.backgroundColor = '#f8d7da';
            container.style.color = '#721c24';
            container.style.borderLeft = '4px solid #dc3545';
        }

        container.style.display = 'block';
        container.scrollIntoView({behavior: 'smooth', block: 'nearest'});
    }
}
